module.exports = __webpack_public_path__ + "f23f3313a68b6b9ef721a7bcad254968.pdf";